<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-info-detail') }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-1">
                          <!-- <p>
                                {{SearchResult}}
                            </p> -->
                            <div class="col-sm-12">
                                  <hr>
                                    <div class="text-center p-5" v-if="loading">
                                        <div class="spinner-border text-secondary" role="status" v-if="loading">
                                        <span class="sr-only"><p>{{ $t('website.website-info-detail') }}</p></span>
                                    </div>
                                </div>
                                  <p v-if="dataResult.visitors"><b>{{ $t('website.visitors') }}: </b> {{dataResult.visitors}}</p>
                                  <p v-if="dataResult.ip_address"><b>{{ $t('website.ip') }}: </b> {{dataResult.ip_address}}</p>
                                  <p v-if="dataResult.domain_name"><b>{{ $t('website.domain_name') }}: </b> {{dataResult.domain_name}}</p>
                                  <p v-if="dataResult.link_ipv6_address"><b>{{ $t('website.visitors') }}: </b> {{dataResult.link_ipv6_address}}</p>
                                  <p v-if="dataResult.ip_location"><b>{{ $t('website.ip_location') }}: </b> {{dataResult.ip_location}}</p>
                                  <p v-if="dataResult.ip_reverse_dns"><b>{{ $t('website.ip_reserve_dns') }}: </b> {{dataResult.ip_reverse_dns}}</p>
                                  <p v-if="dataResult.hosting_company"><b>{{ $t('website.hosting_company') }}: </b> {{dataResult.hosting_company}}</p>
                                  <p v-if="dataResult.hosting_ip_range"><b>{{ $t('website.hosting_ip_range') }}: </b> {{dataResult.hosting_ip_range}}</p>
                                  <p v-if="dataResult.hosting_address"><b>{{ $t('website.hosting_address') }}: </b> {{dataResult.hosting_address}}</p>
                                  <p v-if="dataResult.hosting_country"><b>{{ $t('website.hosting_country') }}: </b> {{dataResult.hosting_country}}</p>
                                  <p v-if="dataResult.hosting_phone"><b>{{ $t('website.hosting_phone') }}: </b> {{dataResult.hosting_phone}}</p>
                                  <p v-if="dataResult.cidr"><b>{{ $t('website.cidr') }}: </b> {{dataResult.cidr}}</p>
                                  <p v-if="dataResult.hosting_cidr"><b>{{ $t('website.hosting_cidr') }}: </b> {{dataResult.hosting_cidr}}</p>
                            </div>
                        </div>
                    </div>
                   </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: '/website-info',
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            dataResult: {
            //   "visitors": "",
            //   "ip_address": "",
            //   "link_ipv6_address": "",
            //   "ip_location": "IDN",
            //   "ip_reverse_dns": "202.158.15.77",
            //   "hosting_company": "Indonesia Network Information Center",
            //   "hosting_ip_range": "202.158.8.0 - 202.158.15.255",
            //   "hosting_address": "Indonesian Network Information Center, Id-Nic, Cyber Building 11Th Floor, Jakarta 12710",
            //   "hosting_country": "Indonesia",
            //   "hosting_phone": "+62-21-52960634, +62-274-487711, +62-21-52921111, +62-21-52921368, +62-21-5659841, +62-21-7941177, +",
            //   "hosting_website": "www.idnic.net, www.ardhglobal.com",
            //   "cidr": "202.158.8.0/21",
            //   "hosting_cidr": "202.158.8.0/21"
            },
            search:false,
            title: this.$t('website.website-info-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-info'),
               href: "/website-info"
                },
                {
                text: this.$t('website.website-info-detail'),
                active: true
                }
            ],
        }
    },
    methods:{
        getWebsiteDetail(){
        this.loading = true;
          WebsiteService.getWebInfoDetail(this.id)
          .then(response => {
                    // console.log(response);
                    this.dataResult = response.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = flase;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getWebsiteDetail();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>